import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const intakeFormRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () => import("@pages/panelPages/intakeForm/intakeFormPage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.intakeFormList", [], "index", "main");
        return {};
      },
    },
    permissions: ["staff", "patient", "doctor"],
  },
  {
    route: {
      path: path.edit.route,
      lazy: () => import("@pages/panelPages/editIntakeForm/editIntakeForm"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.editIntakeForm",
            [{ title: "pageTitle.intakeFormList", url: path.list.link() }],
            "edit",
          );
        return {};
      },
    },
    permissions: ["staff", "patient", "doctor"],
  },
  {
    route: {
      path: path.view.route,
      lazy: () => import("@pages/panelPages/editIntakeForm/editIntakeForm"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.viewIntakeForm",
            [{ title: "pageTitle.intakeFormList", url: path.list.link() }],
            "view",
          );
        return {};
      },
    },
    permissions: ["staff", "patient", "doctor"],
  },
];
